import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import * as state from 'state';
import * as Core from 'components/core';

interface Props {}

export const TrialFontsButton: FC<Props> = () => {
  const { t } = useTranslation();

  return (
    <Core.Button
      secondary
      onClick={() => {
        state.toggleTrialFontsForm();
      }}
    >
      {t('family.downloadTrialFonts')}
    </Core.Button>
  );
};

TrialFontsButton.displayName = 'Families.TrialFontsButton';

export default TrialFontsButton;
